module.exports = __webpack_public_path__ + "img/purchase9.d2bb2bb9.png";